// extracted by mini-css-extract-plugin
module.exports = {"primary":"#0065b8","primaryLight":"#e1effe","primaryHover":"#003D6F","primaryActive":"#1091FB","contrast":"#000"};